import config from '../config';
import { authHeader, handleResponse } from './helper';
import { getCookie } from './cookies';
import { apiClinicalUrl, apiGeneralUrl } from '../config';

export const getExamsByPatient = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };

  const url = new URL(`${apiClinicalUrl}/exams`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getExamInputs = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };

  const url = new URL(`${apiClinicalUrl}/exams/getExam/${params.admissionPatientExamId}`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getPatientExam = async (admissionPatientExamId, params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };

  const url = new URL(`${apiClinicalUrl}/patients/exams/${admissionPatientExamId}`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const initializeExam = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify({
      admission_patient_exam_id: params.admissionPatientExamId
    })
  };

  const url = new URL(`${apiClinicalUrl}/exams/initialize`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const updateExamState = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify({
      admission_patient_exam_id: params.admissionPatientExamId,
      admission_patient_exam_state: params.exam_state,
      ...(params.only_update_save_admin && { only_update_save_admin: params.only_update_save_admin }),
      ...(params.applyExpertAutoFill && { applyExpertAutoFill: true }),
    })
  };

  const url = new URL(`${apiClinicalUrl}/exams/updateExamState`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const saveExam = async (params) => {
  const countryCode = getCookie('country_code');
  let body = {
    ...params.body,
    country_code: countryCode
  }
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(body)
  };

  const url = new URL(`${apiClinicalUrl}/exams/saveExam/${params.type}/${params.admissionPatientExamId}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const calculateExamResult = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params.body)
  };

  const url = new URL(`${apiClinicalUrl}/exams/calculateResult/${params.admissionPatientExamId}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getCalculatorData = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };
  const url = new URL(`${apiClinicalUrl}/calculators/getCalculatorData`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const executeProcedureCalculator = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',

      ...authHeader(),
    },
    body: JSON.stringify(params.body)
  };
  const url = new URL(`${apiClinicalUrl}/calculators/executeProcedureCalculator`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getDocuments = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    }
  };

  const url = new URL(`${apiClinicalUrl}/exams/getDocuments/${params.admissionPatientExamId}/${params.type}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const uploadDocument = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(params.body)
  };

  const url = new URL(`${apiClinicalUrl}/exams/uploadDocuments/${params.admissionPatientExamId}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const deleteDocument = async (params) => {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  const url = new URL(`${apiClinicalUrl}/exams/deleteDocument/${params.examsDocumentId}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const checkValidityExam = async params => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };

  const url = new URL(`${apiClinicalUrl}/exams/validate/${params.patient_id}/${params.exam_id}/${params.admissionPatientId}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const checkRxValidityExam = async params => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };

  const url = new URL(`${apiClinicalUrl}/exams/validateRx/${params.patient_id}/${params.exam_id}/${params.admissionPatientId}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getReport = async params => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    }
  };

  const url = new URL(`${apiGeneralUrl}/reports/getReport`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getExamsByType = async params => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    }
  };

  const url = new URL(`${apiClinicalUrl}/exams/getExamsByType`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const assingDoctor = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    }
  };

  const url = new URL(`${apiClinicalUrl}/exams/assingDoctor/${params.admissionPatientId}/${params.admissionPatientExamId}`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const summaryLaboratory = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    }
  };
  const url = new URL(`${apiClinicalUrl}/exams/summaryLaboratory`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
}

export const traceabilityReport = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    }
  };
  const url = new URL(`${apiClinicalUrl}/exams/getTraceabilityReport`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
}

export const getExamsSignature = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    }
  };

  const url = new URL(`${apiClinicalUrl}/exams/getExpertExams`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getExpertExamRecord = async (admissionPatientExamId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };

  const url = new URL(`${apiClinicalUrl}/exams/getExpertExam/${admissionPatientExamId}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const signExpertBulk = async (admissionPatientExamIds) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify({ admissionPatientExamIds: admissionPatientExamIds }),
  };

  const url = new URL(`${apiClinicalUrl}/exams/signExpertBulk`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const signExpertByState = async ({ admissionPatientExamId, stateValue }) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify({
      admissionPatientExamId,
      stateValue,
    }),
  };

  const url = new URL(`${apiClinicalUrl}/exams/signExpertByState`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getFormSignature = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    }
  };

  const url = new URL(`${apiClinicalUrl}/exams/getExpertFields/${params.admissionPatientExamId}`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const updateSignatureState = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params.body),
  };

  const url = new URL(`${apiClinicalUrl}/exams/updateExpertFields/${params.type}/${params.admissionPatientExamId}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const updateLaboratoryExams = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const url = new URL(`${apiClinicalUrl}/exams/updateLaboratoryExams/${params.admissionPatientId}/${params.state}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getExamResults = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const url = new URL(`${apiClinicalUrl}/exams/getResults/${params.admissionPatientId}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const validateExamsCriterions = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };

  const url = new URL(`${apiClinicalUrl}/exams/validateExamsCriterions/${params.id}`);
  return await fetch(url, requestOptions).then(handleResponse);
};


export const updateExamsData = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };
  const url = new URL(`${apiClinicalUrl}/laboratory/synlab/getResults/`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const getLinkedExam = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };
  const url = new URL(`${apiClinicalUrl}/exams/linkedExam/${params.admissionPatientExamId}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const setLinkedExamId = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify({ linked_exam_id: params.linkedExamId }),
  };

  const url = new URL(`${apiClinicalUrl}/exams/setLinkedExamId/${params.admissionPatientExamId}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const createExamReport = async (params) => {
  const countryCode = getCookie('country_code');

  let body = {
    'id': params.id,
    'type': params.type || 'exam',
    'group_type': params.group_type,
    'group_type_name': params.group_type_name,
    'admission_patient_exam_id': params.admission_patient_exam_id,
    'countryCode': countryCode.toLowerCase(),
    'output': 'pdf'
  };

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getCookie('user'),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(body),
  };

  const urlString = `${config.apiReportUrl}/generate`;

  const url = new URL(urlString);

  const response = await fetch(url, requestOptions);
  const pdf = await response.text();
  return { pdf };
};

export const getInterconsultaExams = async () => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };

  const url = new URL(`${apiClinicalUrl}/exams/getInterconsultaExams`);
  return await fetch(url, requestOptions).then(handleResponse);
};